import React from "react";

export class CookiePolicyDE extends React.Component {
    render() {
        return (
            <>
                <p>
                    Letztes Update: <b>28/11/2024</b>
                    <br />
                    <br />
                </p>
                <p>
                    Dieses Dokument wurde gemäß der EU-Verordnung 2016/679 (der "GDPR") erstellt, damit die Nutzer verstehen können, welche Cookies installiert werden, wenn sie ein
                    DeepUnity PACSonWEB-Portal (die "Website") nutzen.
                </p>
                <h2>1. Verantwortlicher und Datenschutzbeauftragter</h2>
                <p>
                    DH Healthcare GmbH, mit Sitz in der Konrad-Zuse-Platz 1-3, 53227 Bonn, Germany, ist der Verantwortlicher der personenbezogenen Daten (die Daten) der Nutzer der
                    Website, die mit Hilfe von Cookies gesammelt werden. Für jede Anfrage können Sie sich an DH Healthcare GmbH unter der oben genannten physischen Adresse oder
                    über die EMail-Adresse wenden.
                    <br />
                    <br />
                    DH Healthcare GmbH hat einen Datenschutzbeauftragten ("DSB") ernannt, der unter Dpo.belgium@dedalus.eu kontaktiert werden kann.
                </p>
                <h2>2. Von DH Healthcare GmbH verarbeitete Daten</h2>
                <p>
                    Die Navigation auf der Website beinhaltet die Verwendung von Cookies, d.h. kurzen Textabschnitten, die die besuchten Websites an den Browser des Nutzers senden,
                    wo sie gespeichert und bei späteren Besuchen an dieselben Websites übermittelt werden. Während des Besuchs einer Website kann der Nutzer auch Cookies von
                    anderen Websites oder Webservern auf seinem Computer erhalten (so genannte "Drittanbieter"-Cookies).
                    <br />
                    <br />
                    Es kann unterschieden werden zwischen:
                    <br />
                    a. Technische Cookies, die die Durchführung von Aktivitäten im Zusammenhang mit dem Betrieb der Website ermöglichen.
                    <br />
                    <br />
                    b. Profilierungs-Cookies, die dazu dienen, das Nutzerverhalten zu analysieren und gegebenenfalls Werbebotschaften entsprechend den vom Nutzer während der
                    Navigation geäußerten Präferenzen zu versenden.
                    <br />
                    <br />
                    c. Lokale Speicherung, die die Durchführung von Aktivitäten im Zusammenhang mit dem Betrieb der Website ermöglicht.
                </p>
                <p>
                    <br />
                    Diese Website verwendet die folgenden Cookies:
                </p>
                <h3>a) Technische Cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Host</th>
                            <th>Kategorie</th>
                            <th>Beschreibung</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>.ASPXAUTH</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>DeepUnity PACSonWEB-Portal-Authentifizierung.</td>
                        </tr>
                        <tr>
                            <td>ASP.NET_SessionId</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>DeepUnity PACSonWEB-Portal-Sitzungsnummer.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedNecessaryCookies</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Dieses Cookie wird gesetzt, wenn Sie sich entscheiden, alle Cookies zuzulassen, und registriert, wann es gesetzt wurde.</td>
                        </tr>
                        <tr>
                            <td>.AspNetCore.Culture </td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Zeichnet die Sprachauswahl auf, sobald sie manuell geändert wird.</td>
                        </tr>
                        <tr>
                            <td>POWLanguage</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Zeichnet die Sprachauswahl auf, sobald sie manuell geändert wird (die Browsersprache wird als Standard verwendet).</td>
                        </tr>
                        <tr>
                            <td>RETURNSCU</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Kundenportal, bei dem Sie sich angemeldet haben.</td>
                        </tr>
                        <tr>
                            <td>Dobco.LocalImageCaches</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Registriert die lokalen Bild-Caches, die mit dem Benutzer verknüpft sind.</td>
                        </tr>
                        <tr>
                            <td>Dobco.ExternalLogin</td>
                            <td>Dobco</td>
                            <td>Erforderlich</td>
                            <td>Dies wird verwendet, um den Status über einen externen Anmelde-Roundtrip hinweg zu speichern. Dies ist aus Sicherheitsgründen erforderlich, um CSRF- und Replay-Angriffe zu verhindern. Das Cookie wird verschlüsselt.</td>
                        </tr>
                        <tr>
                            <td>Dobco.AcceptedAllCookies </td>
                            <td>Dobco</td>
                            <td>Funktionsfähig</td>
                            <td>Dieses Cookie wird gesetzt, wenn Sie sich entscheiden, alle Cookies zuzulassen, und registriert, wenn es gesetzt wird.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>b) Analyse-/Profilierungs-Cookies</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Host</th>
                            <th>Dauer</th>
                            <th>Kategorie</th>
                            <th>Beschreibung</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>_GA</td>
                            <td>Google</td>
                            <td>2 Jahre</td>
                            <td>Analytisch</td>
                            <td>Dient zur Unterscheidung von Benutzern.</td>
                        </tr>
                        <tr>
                            <td>_GID</td>
                            <td>Google</td>
                            <td>24 Stunden</td>
                            <td>Analytisch</td>
                            <td>Dient zur Unterscheidung von Benutzern.</td>
                        </tr>
                        <tr>
                            <td>_GA_&lt;container_id&gt;</td>
                            <td>Google</td>
                            <td>2 Jahre</td>
                            <td>Analytisch</td>
                            <td>Wird verwendet, um den Sitzungsstatus zu erhalten.</td>
                        </tr>
                    </tbody>
                </table>
                <h3>c) Lokale Speicherung (Host: Dobco; Kategorie: Notwendig)</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Name</th>
                            <th>Beschreibung</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>cookie-shownNews</td>
                            <td> Die letzte Gelegenheit, bei der Sie die Bekanntmachungen geöffnet haben.</td>
                        </tr>
                        <tr>
                            <td>POWHomerBGuid</td>
                            <td> ID für die Nutzung von HomeReading.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3StudyTutorial</td>
                            <td>Erfasst, ob das Tutorial bereits gezeigt wurde.</td>
                        </tr>
                        <tr>
                            <td>POW3SharingOtherDestinationSettings</td>
                            <td> Bevorzugte Einstellungen für die gemeinsame Nutzung einer Studie.</td>
                        </tr>
                        <tr>
                            <td>printing_check_openByDefault</td>
                            <td> Bevorzugte Einstellung für den Druck einer Untersuchung.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginSource</td>
                            <td> Kundenportal, bei dem Sie sich angemeldet haben.</td>
                        </tr>
                        <tr>
                            <td>cookie-acceptedPOW3Cookies</td>
                            <td> Erfasst, ob die Cookie-Richtlinie bereits angezeigt wurde.</td>
                        </tr>
                        <tr>
                            <td>ShownImportNews</td>
                            <td> Aufzeichnung der bereits gezeigten wichtigen Nachrichtenfakten.</td>
                        </tr>
                        <tr>
                            <td>Reportfontsize</td>
                            <td> Schriftgröße des Berichts im Viewer.</td>
                        </tr>
                        <tr>
                            <td>cookie-POW3LoginOption</td>
                            <td> Wie Sie sich angemeldet haben (Patient/Arzt)</td>
                        </tr>
                        <tr>
                            <td>cookie-uniqueBrowserIdentifier</td>
                            <td>
                                Identifiziert Ihren Browser eindeutig innerhalb von DeepUnity PACSonWEB. Er wird verwendet, um festzustellen, ob Sie bei der Anmeldung zur Eingabe
                                eines OTPs aufgefordert werden oder nicht.
                            </td>
                        </tr>
                        <tr>
                            <td>cookie-last-audio-out-volume</td>
                            <td> Speichert die zuletzt verwendete Lautstärke.</td>
                        </tr>
                        <tr>
                            <td>cookie-PreferredRecognitionLanguage</td>
                            <td> Speichert Ihre bevorzugte Spracherkennungssprache.</td>
                        </tr>
                        <tr>
                            <td>cookie-scalingFactorConfiguration</td>
                            <td>Speichert Ihren bevorzugten Skalierungsfaktor und die entsprechende Startauflösung.</td>
                        </tr>
                        <tr>
                            <td>cookie-dontShowPopupForNewsIds</td>
                            <td>Gibt an, welche Nachrichten-Popups Sie nicht mehr sehen möchten.</td>
                        </tr>
                    </tbody>
                </table>
                <p>
                    Während notwendige technische Cookies vom Nutzer der Website nicht abgelehnt werden können, da sie für die Website selbst streng funktional sind, kann der
                    Nutzer frei entscheiden, ob er die Verwendung von Analyse-, Profilierungs- und nicht unbedingt notwendigen Cookies akzeptiert oder ablehnt. Der Nutzer kann
                    seine Entscheidungen in Bezug auf Cookies über die Funktion "Cookies-Einstellung ändern" auf der Website (Abschnitt "Legal") festlegen und überprüfen.
                </p>
                <h2>3. Zwecke und Rechtsgrundlage der Verarbeitung</h2>
                <p>
                    Mit der Verwendung von Cookies werden die folgenden Zwecke verfolgt:
                    <br />
                    <br />
                    3.1. Ermöglichung der Navigation auf der Website und ihrer reibungslosen Funktionalität. Die Rechtsgrundlage für die Verarbeitung ist die Bereitstellung von
                    Dienstleistungen im Zusammenhang mit der Website für die Nutzer und das berechtigte Interesse von Dedalus, eine funktionierende Website zu haben.
                    <br />
                    <br />
                    3.2. Zur Erfüllung von Verpflichtungen, die sich aus geltenden Gesetzen, Verordnungen oder EU-Rechtsvorschriften ergeben, oder zur Erfüllung von Anfragen von
                    Behörden. Die Rechtsgrundlage für die Verarbeitung ist die Verpflichtung von Dedalus, zwingende Rechtsvorschriften einzuhalten.
                    <br />
                    <br />
                    3.3. Das Verhalten des Nutzers zu analysieren und ihm möglicherweise Werbenachrichten entsprechend den von ihm während der Navigation geäußerten Präferenzen zu
                    senden. Die Rechtsgrundlage für die Verarbeitung ist in diesem Fall die Zustimmung des Betroffenen.
                    <br />
                    <br />
                    3.4. Für die Verteidigung der Rechte von Dedalus im Rahmen eines eventuellen Rechtsstreits, auch vor Gericht. Die Rechtsgrundlage für die Verarbeitung ist das
                    berechtigte Interesse des Eigentümers, seine Rechte zu schützen.
                    <br />
                    <br />
                    Die Übermittlung der Daten ist fakultativ, aber (außer im Falle einer Verarbeitung auf der Grundlage einer Einwilligung) verhindert die Nichtbereitstellung der
                    Daten, dass der Verantwortliche die Navigation auf der Website zulässt.
                </p>
                <h2>4. Empfänger der Daten</h2>
                <p>
                    Die Daten können weitergegeben werden:
                    <br />
                    <br />
                    (a) an Dritte, die in Übereinstimmung mit dem Zweck der Verarbeitung bestimmte Tätigkeiten in Bezug auf die Daten ausführen müssen, oder an Dienstleister des
                    Verantwortlichen.
                    <br />
                    (b) an Behörden, Einrichtungen und/oder Parteien, denen die Daten aufgrund zwingender gesetzlicher oder vertraglicher Bestimmungen offengelegt werden müssen.
                    <br />
                    (c) unter anderen Umständen, wie z. B. bei Übernahmen und Verkäufen an potenzielle Drittunternehmen, wenn wir erwarten, dass wir unser Geschäft ganz oder
                    teilweise verkaufen oder übertragen.
                </p>
                <h2>5. Übermittlung von Daten außerhalb des Europäischen Wirtschaftsraums</h2>
                <p>
                    Was die mögliche Übermittlung von Daten in Länder außerhalb des Europäischen Wirtschaftsraums betrifft, so erfolgt die Verarbeitung nach einer der gesetzlich
                    zulässigen Methoden, d.h. durch die Auswahl von Empfängern, die in Ländern ansässig sind, die von der Europäischen
                </p>
                <h2>6. Aufbewahrung der Daten</h2>
                <p>
                    Die Daten werden nur so lange aufbewahrt, wie es für die Zwecke, für die sie erhoben wurden, erforderlich ist, wobei die Grundsätze der
                    Aufbewahrungsbeschränkung und -minimierung eingehalten werden. Die Aufbewahrungsfristen der Cookies sind im vorhergehenden Abschnitt 2 definiert. Für die Daten,
                    deren Verarbeitung auf der Zustimmung des Betroffenen beruht, wird festgelegt, dass diese bis zum Widerruf der Zustimmung aufbewahrt werden.
                </p>
                <h2>7. Rechte der betroffenen Personen</h2>
                <p>
                    Bei Vorliegen der entsprechenden rechtlichen Voraussetzungen kann die betroffene Person von dem Verantwortlichen oder dem DSB Auskunft über ihre Daten
                    verlangen, sie berichtigen oder löschen lassen oder ihrer Verarbeitung widersprechen, die Einschränkung der Verarbeitung in den in Artikel 18 DSGVO
                    <br />
                    vorgesehenen Fällen verlangen sowie die sie betreffenden Daten in einem strukturierten, gängigen und maschinenlesbaren Format in den in Artikel 20 DSGVO
                    vorgesehenen Fällen erhalten.
                    <br />
                    <br />
                    Darüber hinaus hat der Nutzer das Recht, seine Einwilligung zur Verarbeitung jederzeit zu widerrufen, ohne dass die Rechtmäßigkeit, der von dem Verantwortlichen
                    vor dem Widerruf vorgenommenen Verarbeitung berührt wird.
                    <br />
                    <br />
                    Entsprechende Anträge sind schriftlich an den Verantwortlichen unter den oben genannten Adressen zu richten.
                    <br />
                    <br />
                    In jedem Fall kann der Betroffene eine Beschwerde beim Garanten für den Schutz personenbezogener Daten einreichen, wenn er der Meinung ist, dass die
                    Verarbeitung seiner Daten gegen die geltenden Vorschriften verstößt.
                </p>
            </>
        );
    }
}
